// Test IDs for dish photos. A photo is optional, so the e2e agent needs to tell
// "this dish has a picture" from "this dish falls back to its initials" — hence a
// distinct id for the image and for the initials tile, in the row and in the
// full-screen overlay. Keys camelCase, values kebab-case — see auth.js.

export const PHOTO = {
	thumbButton: (dishId) => `dish-photo-${dishId}`,
	thumbImage: (dishId) => `dish-photo-image-${dishId}`,
	thumbInitials: (dishId) => `dish-photo-initials-${dishId}`,
	overlay: 'photo-overlay',
	overlayClose: 'photo-overlay-close',
	overlayImage: 'photo-overlay-image',
	overlayInitials: 'photo-overlay-initials',
};
